/*
  hm-popup-quiz.js — Hairmosa, fenêtre quiz de capture d'e-mail (remplace la capture classique).

  Parcours et règles : ce script n'en contient aucune. L'ordre des questions, les longueurs, les
  paquets, le tour de tête, la lace, les orientations, les produits et les redirections viennent
  de assets/hm-quiz-matrice.js (window.HMQuizMatrice, fichier généré depuis la matrice) lu par
  assets/hm-quiz-resolution.js (window.HMQuizResolution, testé hors thème contre chaque
  combinaison de la matrice). Délais et date de livraison : assets/hm-livraison.js
  (window.HMLivraison), source unique partagée avec les fiches produit. Ces trois scripts ne sont
  chargés qu'à l'ouverture du quiz.

  Écran de résultat : titre, photo et variantes viennent de /products/<handle>.js ; « sur
  commande », paiement en plusieurs fois, ligne de livraison, message d'erreur d'ajout et
  garanties sont relus sur la fiche du produit (même bloc JSON que la fiche s'envoie à elle-même,
  `<script data-hm-donnees>`, et sa liste `.hm-garanties`) : une seule source de vérité, jamais
  une recopie. (L'API de rendu de section ?section_id= a été essayée puis abandonnée : sur un
  gabarit JSON, l'identifiant réel est préfixé par le gabarit — ex. template--123__main — et
  imprévisible depuis ce script ; la page complète est plus lourde mais fiable.)

  Réglages et textes : tout vient de data-hm-quiz-donnees (JSON déposé par
  sections/hm-popup-quiz.liquid) et des attributs data- sur le balisage lui-même. Rien n'est
  écrit en dur ici.
*/
(function () {
  'use strict';

  function num(v) { var n = parseFloat(v); return isNaN(n) ? 0 : n; }

  function $(root, sel) { return root.querySelector(sel); }
  function $$(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function racine() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function emit(nom, detail) { document.documentElement.dispatchEvent(new CustomEvent(nom, { bubbles: true, detail: detail })); }

  /* Format monétaire de la boutique : même utilitaire que assets/hm-produit.js (copie fidèle,
     aucune donnée de prix n'est ici recalculée, seulement mise en forme). */
  function money(cents, format) {
    var f = String(format || '{{amount}}'), k = (f.match(/\{\{\s*(\w+)\s*\}\}/) || [])[1] || 'amount';
    var mil = k.indexOf('comma_separator') > -1 ? '.' : k.indexOf('space') > -1 ? ' ' : k.indexOf('apostrophe') > -1 ? "'" : ',';
    var sep = k.indexOf('comma_separator') > -1 || k.indexOf('with_space') > -1 ? ',' : '.';
    var parts = (Math.round(cents) / 100).toFixed(k.indexOf('no_decimals') > -1 ? 0 : 2).split('.');
    var i = parts[0], d = parts[1];
    i = i.replace(/\B(?=(\d{3})+(?!\d))/g, mil);
    var montant = d && d !== '00' ? i + sep + d : i;
    return f.replace(/\{\{.*?\}\}/, montant).replace(/<[^>]+>/g, '').trim()
      .replace(/(\d)\s*(\D)$/, '$1 $2').replace(/^(\D)\s*(\d)/, '$1 $2');
  }
  /* Espace insécable entre le montant et le symbole de la devise. */
  function moneyInsecable(cents, format) {
    return money(cents, format).replace(/(\d) (\D)$/, '$1 $2').replace(/^(\D) (\d)/, '$1 $2');
  }

  function remplacer(texte, vars) {
    return String(texte || '').replace(/\[([a-zA-Z]+)\]/g, function (m, cle) {
      return Object.prototype.hasOwnProperty.call(vars, cle) && vars[cle] != null ? String(vars[cle]) : '';
    });
  }

  function clarity(cle, valeur) {
    try {
      if (typeof window.clarity === 'function') window.clarity('set', cle, valeur);
    } catch (e) { /* Clarity absent ou bloqué : sans conséquence. */ }
  }

  /* Modalité de la dernière interaction. Déclarée ici, en tête de module, et non dans la
     fonction d'ouverture : elle est lue au moment où la fenêtre s'ouvre, et une déclaration
     plus bas serait encore vide à cet instant.

     Sert uniquement à l'anneau de focus de la croix de fermeture. À l'ouverture, le focus est
     posé par le script (accessibilité : il doit entrer dans la fenêtre), sans qu'aucune
     interaction n'ait eu lieu sur ce bouton. WebKit considère alors ce focus comme « visible »
     et dessine l'anneau, y compris après un tap — d'où une croix qui paraît sélectionnée.
     On ne supprime pas le focus, on note seulement d'où il vient. Écoute en capture pour
     précéder tout autre gestionnaire, et sans aucun travail : un booléen. */
  var parClavier = false;
  document.addEventListener('keydown', function () { parClavier = true; }, true);
  document.addEventListener('pointerdown', function () { parClavier = false; }, true);

  function stockage() {
    try {
      var t = '__hm_quiz_test__';
      window.localStorage.setItem(t, '1');
      window.localStorage.removeItem(t);
      return window.localStorage;
    } catch (e) {
      return null;
    }
  }

  /* ---------- Chargement différé : la matrice, la résolution et la livraison ne sont demandées
     qu'à l'ouverture du quiz (adresses posées en data-js-* par la section), jamais au chargement
     de la page. Sur une fiche produit, hm-livraison.js est déjà là : il n'est pas redemandé. */
  function chargerScript(src) {
    return new Promise(function (resolve, reject) {
      if (!src) { reject(new Error('adresse de script absente')); return; }
      var s = document.createElement('script');
      s.src = src;
      s.onload = function () { resolve(); };
      s.onerror = function () { reject(new Error('script illisible : ' + src)); };
      document.head.appendChild(s);
    });
  }

  /* ---------- Lecture du produit recommandé ---------- */
  async function recupererFiche(url) {
    try {
      var res = await fetch(url, { credentials: 'same-origin' });
      if (!res.ok) return null;
      var html = await res.text();
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var tag = doc.querySelector('script[data-hm-donnees]');
      if (!tag) return null;
      return { json: JSON.parse(tag.textContent), garanties: doc.querySelector('.hm-garanties') };
    } catch (e) {
      console.warn('[hm-popup-quiz] Lecture de la fiche produit impossible :', e);
      return null;
    }
  }
  async function recupererProduit(url) {
    try {
      var res = await fetch(url, { credentials: 'same-origin' });
      if (!res.ok) return null;
      return await res.json();
    } catch (e) {
      console.warn('[hm-popup-quiz] Lecture du produit impossible :', e);
      return null;
    }
  }

  /* Écran affiché pour chaque question de chaque parcours (matrice.parcours donne l'ordre). Les
     écrans longueur et taille sont communs au Tissage et à la Perruque. */
  var ECRANS = {
    tissage: { texture: 'texture', longueur: 'longueur', taille: 'taille', volume: 'volume' },
    perruque: { teinte: 'teinte', longueur: 'longueur', taille: 'taille', densite: 'densite_perruque', carnation: 'carnation' },
    clipin: { objectif: 'objectif', densite: 'densite_clipin', taille: 'taille_clipin', volume: 'volume_clipin' },
    inconnu: { priorite: 'priorite' },
    conseil: { cheveux: 'cheveux', densite: 'densite_conseil', souhait: 'souhait', quotidien: 'quotidien' }
  };

  class HmPopupQuiz extends HTMLElement {
    connectedCallback() {
    var el = this;
    /* M : matrice ; R : résolution ; L : livraison — renseignés par chargerDonnees(), à l'ouverture. */
    var M = null, R = null, L = null;
    var donneesPretes = null;
    function chargerDonnees() {
      if (!donneesPretes) {
        donneesPretes = Promise.all([
          window.HMQuizMatrice ? null : chargerScript(el.getAttribute('data-js-matrice')),
          window.HMQuizResolution ? null : chargerScript(el.getAttribute('data-js-resolution')),
          window.HMLivraison ? null : chargerScript(el.getAttribute('data-js-livraison'))
        ]).then(function () {
          M = window.HMQuizMatrice; R = window.HMQuizResolution; L = window.HMLivraison;
          if (!M || !R || !L) throw new Error('données du quiz absentes');
        });
      }
      return donneesPretes;
    }
    var jsonTag = $(el, '[data-hm-quiz-donnees]');
    if (!jsonTag) return;
    var config;
    try { config = JSON.parse(jsonTag.textContent); } catch (e) { return; }

    /* Réglage « Forcer l'affichage dans l'éditeur » : n'a d'effet que si la page tourne dans
       l'éditeur de thème (request.design_mode côté Liquid) OU sur le lien d'aperçu d'un thème
       non publié (repéré par la barre que Shopify insère lui-même, #OnlineStorePreviewBarNextData
       — absente pour une visiteuse sur le thème publié). Le panneau d'aperçu intégré à l'éditeur
       n'transmet aucun clic réel à la page ; le lien d'aperçu, lui, se comporte comme un vrai
       navigateur et permet de tester le parcours au clic. Ignore alors le délai, le défilement et
       la mémorisation de fermeture, et ne touche jamais au stockage : fermer la fenêtre pendant la
       configuration ne doit pas empêcher une visiteuse de la voir ensuite. */
    var dansApercu = !!(config.modeEditeur || document.getElementById('OnlineStorePreviewBarNextData'));
    var forcerEditeur = !!(config.forcerEditeur && dansApercu);

    var stock = stockage();
    var CLE_FAIT = 'hm_quiz_v1_termine';
    var CLE_FERME = 'hm_quiz_v1_ferme_le';
    var CLE_ECRAN_EDITEUR = 'hm_quiz_v2_editeur';

    /* Ces règles ne concernent que l'ouverture automatique. L'ouverture au clic (barre d'annonce,
       fiches produit, menu, liens vers la page du quiz) reste possible dans tous les cas. */
    var autoBloquee = false;
    if (!forcerEditeur) {
      if (!stock) autoBloquee = true; // Pas de stockage fiable : on préfère ne jamais afficher plutôt qu'en boucle.
      else if (stock.getItem(CLE_FAIT) === '1') autoBloquee = true;
      else {
        var fermeLe = num(stock.getItem(CLE_FERME));
        var joursMs = Math.max(1, num(config.joursReaffichage) || 7) * 86400000;
        if (fermeLe && (Date.now() - fermeLe) < joursMs) autoBloquee = true;
      }
    }
    /* data-auto : la section autorise l'ouverture automatique sur ce type de page (réglages
       « Déclenchement »). data-mode="page" : quiz affiché dans la page /pages/trouver-mon-produit,
       jamais en fenêtre. */
    var autoPage = el.getAttribute('data-auto') === 'true';
    var modePage = el.getAttribute('data-mode') === 'page';

    var scrim = $(el, '[data-hm-quiz-scrim]');
    var panneau = $(el, '[data-hm-quiz-panneau]');
    var corps = $(el, '[data-hm-quiz-corps]');
    var progres = $(el, '[data-hm-quiz-progres]');
    var etapes = $$(el, '.hm-quiz__etape');
    if (!panneau || !etapes.length) return;

    var estProduit = el.getAttribute('data-est-produit') === 'true';
    var ouvert = false;
    var annule = false;
    var ecranActuel = 'accroche';
    var dernierFocus = null;
    var declencheur = null;
    var scrollAvant = null;
    var silhouettes = null;
    var LONGUEUR_ILLUSTREE_COURTE = 14, LONGUEUR_ILLUSTREE_LONGUE = 32;
    var chargements = {};
    var resultatAffiche = null;

    /* gamme : réponse à la question principale (tissage, perruque, clipin, inconnu) ;
       reponses / libelles : par nom de question de la matrice (texture, longueur, taille…). */
    var state = { gamme: null, reponses: {}, libelles: {} };

    function ecranPar(nom) { return etapes.filter(function (e) { return e.getAttribute('data-ecran') === nom; })[0] || null; }

    /* ---------- Parcours ---------- */
    /* Famille dont on déroule les questions : celle choisie à la question principale, ou celle
       vers laquelle oriente la question 1.D (D3 : la cliente enchaîne sur toute la branche). */
    function famille() {
      if (state.gamme && state.gamme !== 'inconnu') return state.gamme;
      if (state.gamme === 'inconnu' && state.reponses.priorite) return R.orienter(M, state.reponses.priorite);
      return null;
    }
    function chemin() {
      var liste = [{ parcours: null, question: 'gamme', ecran: 'gamme' }];
      function ajouter(nom) {
        (M.parcours[nom] || []).forEach(function (q) { liste.push({ parcours: nom, question: q, ecran: ECRANS[nom][q] }); });
      }
      if (state.gamme === 'inconnu') ajouter('inconnu');
      var f = famille();
      if (f) ajouter(f);
      return liste;
    }
    /* Nombre total de questions du parcours en cours. Tant que la branche n'est pas connue, on
       compte la suite la plus courte possible, pour que la barre ne recule jamais. */
    function totalQuestions() {
      var total = chemin().length;
      if (famille()) return total;
      var plusCourt = Math.min.apply(null, ['tissage', 'perruque', 'clipin', 'conseil'].map(function (n) { return M.parcours[n].length; }));
      return total + plusCourt;
    }
    function indexDansChemin(nom) {
      var liste = chemin();
      for (var i = 0; i < liste.length; i++) if (liste[i].ecran === nom) return i;
      return -1;
    }
    function reponsesFamille() {
      var f = famille(), r = { famille: f };
      (M.parcours[f] || []).forEach(function (q) { r[q] = state.reponses[q]; });
      return r;
    }
    function resoudre() { return famille() ? R.resoudre(M, reponsesFamille()) : null; }

    /* ---------- Produit recommandé : chargé dès qu'il est connu ---------- */
    function handleCourant() {
      var f = famille();
      if (f === 'tissage') return M.produits.tissage[state.reponses.texture] || null;
      if (f === 'perruque') return M.produits.perruque[state.reponses.teinte] || null;
      if (f === 'clipin') return M.produits.clipin;
      return null;
    }
    function charger(handle) {
      if (!handle) return Promise.resolve(null);
      if (!chargements[handle]) {
        var url = racine() + 'products/' + handle;
        chargements[handle] = Promise.all([recupererProduit(url + '.js'), recupererFiche(url)]).then(function (r) {
          return { url: url, produit: r[0], fiche: r[1] };
        });
      }
      return chargements[handle];
    }

    /* ---------- Déclenchement ---------- */
    var selecteurTouche = false;
    function surChangementSelecteur(e) {
      var n = e.target && e.target.name;
      if (n && n.indexOf('hm-') === 0) selecteurTouche = true;
    }
    if (estProduit) document.addEventListener('change', surChangementSelecteur, true);

    function barreCollanteVisible() {
      var barre = document.querySelector('[data-hm-collante], [data-hm-collante-btn]');
      barre = barre && barre.closest ? barre.closest('[data-hm-collante]') || barre : barre;
      if (!barre) return false;
      return barre.classList.contains('is-visible');
    }

    var minuteur = null;
    function nettoyerDeclencheurs() {
      if (minuteur) { clearTimeout(minuteur); minuteur = null; }
      window.removeEventListener('scroll', surScroll);
    }
    function pourcentDefile() {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      if (h <= 0) return 100;
      return Math.min(100, Math.max(0, ((window.scrollY || window.pageYOffset) / h) * 100));
    }
    var enAttenteScroll = false;
    function surScroll() {
      if (enAttenteScroll) return;
      enAttenteScroll = true;
      requestAnimationFrame(function () {
        enAttenteScroll = false;
        if (pourcentDefile() >= num(config.delaiScrollPourcent)) essayerOuvrir();
      });
    }
    function essayerOuvrir() {
      if (ouvert || annule) return;
      if (estProduit && (selecteurTouche || barreCollanteVisible())) {
        annule = true;
        nettoyerDeclencheurs();
        return;
      }
      nettoyerDeclencheurs();
      ouvrirFenetre();
    }

    /* ---------- Ouverture / fermeture ---------- */
    function focusables() {
      return $$(panneau, 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
        .filter(function (n) { return !n.disabled && n.offsetParent !== null; });
    }
    function surTab(e) {
      if (e.key !== 'Tab') return;
      var f = focusables();
      if (!f.length) return;
      var premier = f[0], dernier = f[f.length - 1];
      if (e.shiftKey && document.activeElement === premier) { e.preventDefault(); dernier.focus(); }
      else if (!e.shiftKey && document.activeElement === dernier) { e.preventDefault(); premier.focus(); }
    }
    function surEchap(e) { if (e.key === 'Escape') fermerFenetre('echap'); }

    /* Les données du quiz sont chargées d'abord ; si elles sont illisibles, le quiz ne s'ouvre pas. */
    function ouvrirFenetre() {
      if (ouvert) return;
      ouvert = true;
      chargerDonnees().then(afficherFenetre).catch(function (e) {
        ouvert = false;
        annule = true;
        console.warn('[hm-popup-quiz] Ouverture impossible :', e);
      });
    }
    function afficherFenetre() {
      dernierFocus = declencheur || document.activeElement;
      declencheur = null;
      scrollAvant = window.scrollY || window.pageYOffset;
      el.hidden = false;
      scrim.hidden = false;
      panneau.hidden = false;
      document.documentElement.classList.add('hm-quiz-ouvert');
      document.addEventListener('keydown', surTab);
      document.addEventListener('keydown', surEchap);
      clarity('hm_quiz_ouverture', 'oui');
      initialiserLongueurs();
      aller(forcerEditeur ? restaurerSessionEditeur() : 'accroche');
      var fermerBtn = $(el, '[data-hm-quiz-fermer]');
      if (fermerBtn) {
        /* Le focus entre toujours dans la fenêtre. `data-hm-focus-doux` masque seulement son
           anneau quand l'ouverture ne vient pas du clavier ; il est retiré dès la première
           touche ou dès que le focus part, pour que la navigation clavier le retrouve. */
        if (parClavier) fermerBtn.removeAttribute('data-hm-focus-doux');
        else fermerBtn.setAttribute('data-hm-focus-doux', '');
        fermerBtn.focus();
      }
    }

    /* Mode forcé dans l'éditeur uniquement : mémorise l'écran en cours et les réponses pour la
       session d'édition (sessionStorage, jamais localStorage), pour ne pas avoir à refaire tout
       le parcours à chaque rechargement de l'aperçu quand on modifie un texte. Les écrans de
       résultat dépendent d'un chargement : on reprend alors à la capture e-mail.
       Sans effet sur une visiteuse : ce chemin n'est atteint que si forcerEditeur est vrai. */
    function restaurerSessionEditeur() {
      try {
        var v = JSON.parse(window.sessionStorage.getItem(CLE_ECRAN_EDITEUR));
        if (!v || !v.ecran || !ecranPar(v.ecran)) return 'accroche';
        state.gamme = v.gamme || null;
        state.reponses = v.reponses || {};
        state.libelles = v.libelles || {};
        if (v.ecran === 'resultat' || v.ecran === 'conseil') return resoudre() ? 'capture' : 'accroche';
        if (v.ecran === 'capture') return resoudre() ? 'capture' : 'accroche';
        if (v.ecran !== 'accroche' && indexDansChemin(v.ecran) === -1) return 'accroche';
        charger(handleCourant());
        return v.ecran;
      } catch (e) { return 'accroche'; }
    }
    function memoriserSessionEditeur() {
      try {
        window.sessionStorage.setItem(CLE_ECRAN_EDITEUR, JSON.stringify({ ecran: ecranActuel, gamme: state.gamme, reponses: state.reponses, libelles: state.libelles }));
      } catch (e) { /* ignoré */ }
    }

    function fermerFenetre(raison) {
      if (modePage) return;
      if (!ouvert) return;
      ouvert = false;
      el.hidden = true;
      document.documentElement.classList.remove('hm-quiz-ouvert');
      document.removeEventListener('keydown', surTab);
      document.removeEventListener('keydown', surEchap);
      retirerCssResultat();
      clarity('hm_quiz_fermeture', ecranActuel);
      if (raison !== 'complete' && !forcerEditeur) {
        try { stock.setItem(CLE_FERME, String(Date.now())); } catch (e) { /* ignoré */ }
      }
      if (dernierFocus && dernierFocus.focus) dernierFocus.focus({ preventScroll: true });
      /* La page reprend exactement la position de défilement d'avant l'ouverture. */
      if (scrollAvant !== null) {
        if (Math.abs((window.scrollY || window.pageYOffset) - scrollAvant) > 1) window.scrollTo(window.scrollX || 0, scrollAvant);
        scrollAvant = null;
      }
    }

    /* ---------- Ouverture au clic : fonction unique, exposée en window.HMQuiz.ouvrir ---------- */
    /* Réutilise l'ouverture existante. Annule les déclencheurs automatiques encore en attente : la
       fermeture qui suivra enregistre la date comme aujourd'hui (blocage d'un jour). Sur la page
       dédiée, fait défiler jusqu'au quiz au lieu d'ouvrir une fenêtre en double. */
    function ouvrirAuClic(origine) {
      if (modePage) { allerAuQuiz(); return; }
      if (ouvert) return;
      nettoyerDeclencheurs();
      declencheur = origine || null;
      ouvrirFenetre();
    }
    function allerAuQuiz() {
      var reduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      el.scrollIntoView({ behavior: reduit ? 'auto' : 'smooth', block: 'start' });
      var actif = ecranPar(ecranActuel);
      var titre = actif && $(actif, 'h2');
      if (titre) { titre.setAttribute('tabindex', '-1'); titre.focus({ preventScroll: true }); }
    }
    window.HMQuiz = { ouvrir: ouvrirAuClic };

    /* Tout lien vers /pages/trouver-mon-produit et tout élément [data-hm-quiz-open] ouvrent le quiz
       sur la page courante, sans navigation. Clic venu du menu (Menu mobile Hairmosa) : le menu se
       ferme d'abord, par son propre bouton, puis le quiz s'ouvre une fois sa transition terminée.
       Clic avec une touche de modification (nouvel onglet…) : comportement normal du navigateur. */
    function accesQuiz(cible) {
      var acces = cible && cible.closest ? cible.closest('[data-hm-quiz-open], a[href]') : null;
      if (!acces || el.contains(acces)) return null;
      if (acces.hasAttribute('data-hm-quiz-open')) return acces;
      var url;
      try { url = new URL(acces.getAttribute('href'), window.location.href); } catch (e) { return null; }
      if (url.origin !== window.location.origin) return null;
      return /\/pages\/trouver-mon-produit\/?$/.test(url.pathname) ? acces : null;
    }
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var acces = accesQuiz(e.target);
      if (!acces) return;
      e.preventDefault();
      var menu = acces.closest('[data-hmm-root]');
      var fermerMenu = menu && menu.classList.contains('is-open') ? menu.querySelector('[data-hmm-close]') : null;
      if (fermerMenu) {
        var duree = parseFloat(window.getComputedStyle(menu).getPropertyValue('--hmm-dur')) || 0;
        fermerMenu.click();
        setTimeout(function () { ouvrirAuClic(null); }, duree);
      } else {
        ouvrirAuClic(acces);
      }
    }, true);

    $$(el, '[data-hm-quiz-fermer]').forEach(function (b) {
      b.addEventListener('click', function () { fermerFenetre('fermeture'); });
      /* Dès que la personne touche le clavier, ou dès que le focus quitte la croix, l'anneau
         redevient celui du thème : la marque ne survit pas à l'ouverture qui l'a posée. */
      b.addEventListener('keydown', function () { b.removeAttribute('data-hm-focus-doux'); });
      b.addEventListener('blur', function () { b.removeAttribute('data-hm-focus-doux'); });
    });
    var sortie = $(el, '[data-hm-quiz-sortie]');
    if (sortie) sortie.addEventListener('click', function () { fermerFenetre('sortie'); });
    if (scrim) scrim.addEventListener('click', function () { fermerFenetre('scrim'); });

    /* Écrans de fin : les liens vers la fiche sont des <a href> normaux (même onglet, aucun
       preventDefault) — ferment la fenêtre au clic, en même temps que la navigation démarre.
       Raison « complete » : le parcours est terminé (CLE_FAIT est déjà à 1 depuis validerEmail),
       aucun délai de réaffichage à enregistrer. Même chose pour « Continuer ma visite ». */
    $$(el, '[data-hm-quiz-res-lien], [data-hm-quiz-res-cas-rare-lien], [data-hm-quiz-terminer]').forEach(function (b) {
      b.addEventListener('click', function () { fermerFenetre('complete'); });
    });
    /* Page dédiée : la fenêtre ne se ferme pas ; « Continuer ma visite » ramène au premier écran. */
    if (modePage) {
      $$(el, '[data-hm-quiz-terminer]').forEach(function (b) {
        b.addEventListener('click', function () { aller('accroche'); });
      });
    }

    /* ---------- Navigation entre écrans ---------- */
    /* Étape courante / nombre total de questions du parcours en cours (1re question = 1/5 pour un
       Tissage) ; accroche à 0, capture et écrans de fin à 100 %. */
    function majProgres() {
      if (!progres) return;
      var i = indexDansChemin(ecranActuel);
      var part = ecranActuel === 'accroche' ? 0 : i === -1 ? 1 : (i + 1) / totalQuestions();
      progres.style.width = Math.round(part * 100) + '%';
    }
    function aller(nom, sansFocus) {
      ecranActuel = nom;
      if (forcerEditeur) memoriserSessionEditeur();
      etapes.forEach(function (e) { e.hidden = e.getAttribute('data-ecran') !== nom; });
      majProgres();
      if (nom === 'longueur') afficherGroupeLongueur();
      if (nom === 'capture') preparerCapture();
      clarity('hm_quiz_etape', nom);
      var actif = ecranPar(nom);
      var titre = actif && $$(actif, 'h2').filter(function (h) { return h.offsetParent !== null; })[0];
      if (titre && !sansFocus) { titre.setAttribute('tabindex', '-1'); titre.focus(); }
      if (corps) corps.scrollTop = 0;
    }
    function precedent() {
      if (ecranActuel === 'capture') { var liste = chemin(); return liste[liste.length - 1].ecran; }
      var i = indexDansChemin(ecranActuel);
      return i > 0 ? chemin()[i - 1].ecran : 'accroche';
    }
    $$(el, '[data-hm-quiz-retour]').forEach(function (b) {
      b.addEventListener('click', function () { aller(precedent()); });
    });

    function marquerSelection(bouton, conteneur) {
      $$(conteneur, '.is-sel').forEach(function (n) { n.classList.remove('is-sel'); });
      bouton.classList.add('is-sel');
    }
    /* Changer de branche efface les réponses (et les coches) des questions qui suivent : les
       écrans longueur et taille sont partagés entre Tissage et Perruque. */
    function oublierApres(nomEcran) {
      var garder = nomEcran === 'gamme' ? [] : ['priorite'];
      Object.keys(state.reponses).forEach(function (q) {
        if (garder.indexOf(q) === -1) { delete state.reponses[q]; delete state.libelles[q]; }
      });
      etapes.forEach(function (e) {
        var n = e.getAttribute('data-ecran');
        if (n === 'gamme' || (n === 'priorite' && nomEcran !== 'gamme')) return;
        $$(e, '.is-sel').forEach(function (x) { x.classList.remove('is-sel'); });
      });
    }

    /* ---------- Accroche ---------- */
    $$(el, '[data-hm-quiz-commencer]').forEach(function (b) {
      b.addEventListener('click', function () { aller('gamme'); });
    });

    /* ---------- Questions : un seul gestionnaire pour tous les écrans ---------- */
    etapes.forEach(function (section) {
      var nomEcran = section.getAttribute('data-ecran');
      $$(section, '[data-hm-quiz-reponse]').forEach(function (b) {
        b.addEventListener('click', function () {
          var i = indexDansChemin(nomEcran);
          if (i === -1) return;
          var etape = chemin()[i];
          var valeur = b.getAttribute('data-hm-quiz-reponse');
          var libelle = $(b, 'b') ? $(b, 'b').textContent : '';
          if (etape.question === 'gamme') {
            if (state.gamme !== valeur) oublierApres('gamme');
            state.gamme = valeur;
          } else {
            if (etape.question === 'priorite' && state.reponses.priorite !== valeur) oublierApres('priorite');
            state.reponses[etape.question] = valeur;
            state.libelles[etape.question] = libelle;
          }
          marquerSelection(b, section);
          charger(handleCourant());
          var liste = chemin();
          var suivant = i + 1 < liste.length ? liste[i + 1].ecran : 'capture';
          setTimeout(function () { aller(suivant); }, 260);
        });
      });
    });

    /* ---------- Écran longueur (silhouettes) ---------- */
    /* Longueurs illustratives, volontairement exagérées entre la première silhouette (franchement
       courte) et la dernière (franchement longue), les deux intermédiaires réparties entre les
       deux — sans lien avec les pouces réels, qui viennent de la matrice : cet écran n'affiche
       aucun chiffre, seule l'image porte la décision, l'écart doit donc se voir d'un coup d'œil.
       Plancher à 14" et non 10" (l'extrémité courte de l'étendue calibrée) : en dessous de 14",
       le tracé des cheveux lisses (assets/hm-illustrations.js, fonction cheveux()) revient sur un
       point d'ancrage fixe avant de redescendre, ce qui dessine un petit repli — visible à
       l'écran comme deux points sombres au niveau des oreilles. Plancher relevé ici, spécifique
       au quiz, sans toucher aux valeurs de dessin calibrées ni au rendu de la fiche produit. */
    function initialiserLongueurs() {
      if (silhouettes) return;
      var illustrations = window.HMIllustrations;
      silhouettes = $$(el, '[data-ecran="longueur"] svg.hm-silhouette').map(function (svg) {
        var inst = illustrations ? new illustrations.Silhouette(svg, { texture: svg.getAttribute('data-texture') }) : null;
        return { svg: svg, inst: inst };
      });
      silhouettes.forEach(function (s) {
        var conteneur = s.svg.closest('[data-index]');
        var idx = conteneur ? num(conteneur.getAttribute('data-index')) : 0;
        if (!s.inst || idx < 1) return;
        var pouces = LONGUEUR_ILLUSTREE_COURTE + (LONGUEUR_ILLUSTREE_LONGUE - LONGUEUR_ILLUSTREE_COURTE) * (idx - 1) / 3;
        s.inst.allerA(pouces);
      });
    }
    /* Silhouettes à la texture choisie pour le Tissage ; lisses pour la Perruque. */
    function afficherGroupeLongueur() {
      var groupe = (famille() === 'tissage' && state.reponses.texture) || 'lisse';
      $$(el, '[data-texture-groupe]').forEach(function (g) { g.hidden = g.getAttribute('data-texture-groupe') !== groupe; });
    }

    /* ---------- Capture e-mail ---------- */
    var formulaire = $(el, '[data-hm-quiz-form]');
    var champEmail = $(el, '[data-hm-quiz-email]');
    var erreurEmail = $(el, '[data-hm-quiz-erreur]');
    var boutonCapture = $(el, '[data-hm-quiz-valider]');
    var titreCapture = $(el, '[data-hm-quiz-capture-titre]');
    var sousCapture = $(el, '[data-hm-quiz-capture-sous]');
    var mentionCapture = $(el, '[data-hm-quiz-capture-mention]');
    var texteBoutonCapture = '';

    function emailValide(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }

    /* Parcours sans recommandation (redirection vers une collection, conseil personnalisé) :
       titre et bouton dédiés, ni sous-titre ni mention sous le champ (ils annoncent une sélection). */
    function preparerCapture() {
      var r = resoudre();
      var conseil = !!(r && (r.ecran === 'redirection' || r.ecran === 'conseil_personnalise'));
      var attribut = conseil ? 'data-texte-conseil' : 'data-texte';
      if (titreCapture) titreCapture.textContent = titreCapture.getAttribute(attribut) || '';
      if (boutonCapture) { texteBoutonCapture = boutonCapture.getAttribute(attribut) || ''; boutonCapture.textContent = texteBoutonCapture; }
      if (sousCapture) sousCapture.hidden = conseil || !sousCapture.textContent.trim();
      if (mentionCapture) mentionCapture.hidden = conseil;
    }

    if (formulaire) {
      formulaire.addEventListener('submit', function (e) {
        e.preventDefault();
        var v = (champEmail && champEmail.value || '').trim();
        if (!emailValide(v)) {
          if (erreurEmail) { erreurEmail.textContent = config.textes.erreurEmail || ''; erreurEmail.hidden = false; }
          if (champEmail) champEmail.focus();
          return;
        }
        if (erreurEmail) erreurEmail.hidden = true;
        if (boutonCapture) { boutonCapture.disabled = true; boutonCapture.textContent = config.textes.boutonChargement || texteBoutonCapture; }
        validerEmail(v);
      });
    }

    function entree() {
      if (state.gamme !== 'inconnu') return 'direct';
      return famille() === 'conseil' ? 'je_ne_sais_vraiment_pas' : 'je_ne_sais_pas';
    }

    /* ---------- Propriétés supplémentaires de l'événement Klaviyo ---------- */
    /* Adresse absolue sur la boutique en ligne. Le domaine vient du réglage Liquid shop.url
       (config.boutiqueUrl), jamais de l'adresse courante : le quiz tourne aussi sur le lien
       d'aperçu d'un thème et sur le serveur de développement, dont l'hôte n'est pas celui de la
       boutique. Le chemin, lui, est celui déjà construit par le quiz (racine() porte la locale). */
    function absolu(chemin) {
      var base = String(config.boutiqueUrl || '').replace(/\/+$/, '');
      if (!base || !chemin) return null;
      return base + (chemin.indexOf('/') === 0 ? chemin : '/' + chemin);
    }
    /* Image principale du produit en 800 px, comme l'écran de résultat. /products/<handle>.js
       renvoie une adresse sans protocole (//cdn.shopify.com/…) et déjà suivie d'un ?v=. */
    function imageProduit(produit) {
      var src = produit && produit.featured_image;
      if (!src) return null;
      if (src.indexOf('//') === 0) src = 'https:' + src;
      else if (src.indexOf('/') === 0) src = absolu(src);
      if (!src) return null;
      src = src.replace(/^http:\/\//i, 'https://');
      return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=800';
    }
    /* Ligne de détail de la variante, mêmes valeurs que les lignes de la carte de résultat :
       valeurs d'options Shopify, mots « paquet(s) » et libellés Lace / Bonnet des réglages. */
    function detailVariante(r, variante, varianteLien) {
      var v = variante || varianteLien;
      if (!v || !v.options) return null;
      var t = config.textes || {};
      var morceaux = [v.options[0]];
      if (r.famille === 'perruque') {
        morceaux.push(t.labelLace + ' ' + v.options[1]);
        morceaux.push(t.labelBonnet + ' ' + v.options[2]);
      } else if (r.ecran === 'cas_rare') {
        morceaux.push(r.paquets + ' ' + (r.paquets > 1 ? t.paquetPluriel : t.paquetSingulier));
      } else {
        morceaux.push(v.options[1]);
      }
      return morceaux.join(' · ');
    }
    /* Propriétés réservées à l'événement « Quiz complété » (jamais au profil). Une valeur qui
       n'existe pas pour ce cas laisse la propriété absente : ni chaîne vide, ni null. Le cas rare
       n'a pas de variante vendable (5 paquets) : aucune propriété de prix, comme l'écran. */
    function proprietesResultat(r, donnees, variante, varianteLien) {
      var p = {};
      if (!r) return p;
      if (r.ecran === 'redirection' && r.redirection) {
        var url = absolu(racine() + r.redirection.replace(/^\//, ''));
        if (url) p.url_collection = url;
        return p;
      }
      if (!donnees) return p;
      if (donnees.url && varianteLien) {
        var lien = absolu(donnees.url + '?variant=' + encodeURIComponent(varianteLien.id));
        if (lien) p.url_produit = lien;
      }
      var image = imageProduit(donnees.produit);
      if (image) p.image_produit = image;
      var detail = detailVariante(r, variante, varianteLien);
      if (detail) p.detail_variante = detail;
      if (variante) {
        p.prix_affiche = moneyInsecable(variante.price, config.moneyFormat);
        var barre = num(variante.compare_at_price);
        if (barre > variante.price) {
          p.prix_barre_affiche = moneyInsecable(barre, config.moneyFormat);
          p.economie_affichee = moneyInsecable(barre - variante.price, config.moneyFormat);
        }
        /* Paiement en plusieurs fois : même calcul que l'écran de résultat, nombre d'échéances
           lu sur la fiche du produit (source unique, jamais recopiée ici). */
        var fiche = donnees.fiche && donnees.fiche.json;
        var nb = num(fiche && fiche.reglages && fiche.reglages.echeances);
        if (nb > 0) p.prix_4x_affiche = moneyInsecable(Math.round(variante.price / nb), config.moneyFormat);
      }
      return p;
    }

    async function validerEmail(email) {
      clarity('hm_quiz_email_valide', 'oui');
      var r = resoudre();
      var f = famille();
      var rep = state.reponses;
      var donnees = r && r.handle ? await charger(r.handle) : null;
      var produit = donnees && donnees.produit;
      var variante = r && r.options ? R.trouverVariante(produit, r.longueur, r.options) : null;
      var varianteLien = r && r.optionsLien ? R.trouverVariante(produit, r.longueur, r.optionsLien) : null;

      var proprietes = {
        gamme: f,
        texture: f === 'tissage' ? rep.texture : null,
        volume: (f === 'tissage' || f === 'clipin') ? rep.volume : null,
        longueur: r ? r.longueur : null,
        tranche_taille: state.libelles.taille || null,
        produit_recommande: produit ? produit.title : null,
        entree: entree(),
        longueur_souhaitee: (f === 'tissage' || f === 'perruque') ? rep.longueur : null,
        teinte: rep.teinte || null,
        densite: rep.densite || null,
        carnation: rep.carnation || null,
        objectif_clipin: rep.objectif || null,
        priorite: rep.priorite || null,
        cheveux_actuels: rep.cheveux || null,
        souhait: rep.souhait || null,
        quotidien: rep.quotidien || null,
        orientation: r && r.orientation ? r.orientation : null,
        paquets: r ? r.paquets : null,
        bonnet: r ? r.bonnet : null,
        lace: r ? r.lace : null,
        variante_id: variante ? variante.id : null,
        variante_titre: variante ? variante.title : null,
        prix: variante ? variante.price / 100 : null,
        ecran_final: r ? r.ecran : null
      };
      /* L'inscription à la liste garde l'objet ci-dessus, inchangé : les propriétés ajoutées
         (lien, image, prix, détail de la variante) ne partent que sur l'événement. */
      var proprietesEvenement = Object.assign({}, proprietes, proprietesResultat(r, donnees, variante, varianteLien));
      try {
        if (config.klaviyoCle && config.klaviyoListe) {
          fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(config.klaviyoCle), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: { profile: { data: { type: 'profile', attributes: { email: email, properties: proprietes } } } },
                relationships: { list: { data: { type: 'list', id: config.klaviyoListe } } }
              }
            }),
            keepalive: true
          }).catch(function (e) { console.warn('[hm-popup-quiz] Inscription Klaviyo impossible :', e); });
        }
        if (config.klaviyoCle) {
          fetch('https://a.klaviyo.com/client/events?company_id=' + encodeURIComponent(config.klaviyoCle), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
            body: JSON.stringify({
              data: {
                type: 'event',
                attributes: {
                  properties: proprietesEvenement,
                  metric: { data: { type: 'metric', attributes: { name: 'Quiz complété' } } },
                  profile: { data: { type: 'profile', attributes: { email: email } } }
                }
              }
            }),
            keepalive: true
          }).catch(function (e) { console.warn('[hm-popup-quiz] Événement Klaviyo impossible :', e); });
        }
      } catch (e) {
        console.warn('[hm-popup-quiz] Envoi Klaviyo impossible :', e);
      }

      if (!forcerEditeur) {
        try { stock.setItem(CLE_FAIT, '1'); } catch (e) { /* ignoré */ }
      }

      if (r && r.ecran === 'redirection') {
        fermerFenetre('complete');
        window.location.href = racine() + r.redirection.replace(/^\//, '');
        return;
      }
      if (boutonCapture) { boutonCapture.disabled = false; boutonCapture.textContent = texteBoutonCapture; }
      if (r && r.ecran === 'conseil_personnalise') { aller('conseil'); return; }

      /* Produit illisible (réseau) : rien à afficher de fiable, on ouvre la fiche du produit. */
      if (!r || !produit || !varianteLien) {
        console.warn('[hm-popup-quiz] Recommandation impossible à afficher :', r);
        if (r && r.handle) { fermerFenetre('complete'); window.location.href = racine() + 'products/' + r.handle; }
        return;
      }
      await afficherResultat(r, donnees, variante, varianteLien);
      aller('resultat');
    }

    /* ---------- Écran de résultat ---------- */
    /* assets/hm-produit.css (styles de .hm-quatre-fois, .hm-dispo et .hm-garanties, repris de la
       fiche sans copie) n'est chargé qu'à l'affichage du résultat, et retiré à la fermeture. */
    var ID_CSS_RESULTAT = 'hm-quiz-css-resultat';
    function chargerCssResultat() {
      return new Promise(function (resolve) {
        var href = el.getAttribute('data-css-resultat');
        if (!href || document.getElementById(ID_CSS_RESULTAT)) { resolve(); return; }
        var lien = document.createElement('link');
        lien.id = ID_CSS_RESULTAT;
        lien.rel = 'stylesheet';
        lien.href = href;
        lien.onload = lien.onerror = function () { resolve(); };
        setTimeout(resolve, 3000);
        document.head.appendChild(lien);
      });
    }
    function retirerCssResultat() {
      var lien = document.getElementById(ID_CSS_RESULTAT);
      if (lien && lien.parentNode) lien.parentNode.removeChild(lien);
    }

    function ligneResultat(nom, valeur) {
      var ligne = $(el, '[data-hm-quiz-res-ligne="' + nom + '"]');
      if (!ligne) return;
      ligne.hidden = !valeur;
      var cible = $(ligne, '[data-valeur]');
      if (cible) cible.textContent = valeur || '';
    }

    async function afficherResultat(r, donnees, variante, varianteLien) {
      var produit = donnees.produit;
      var fiche = donnees.fiche && donnees.fiche.json;
      var casRare = r.ecran === 'cas_rare';
      resultatAffiche = { variante: variante, fiche: fiche };

      var titre = $(el, '[data-hm-quiz-res-titre]');
      if (titre) titre.textContent = titre.getAttribute(casRare ? 'data-texte-cas-rare' : 'data-texte') || '';

      var image = $(el, '[data-hm-quiz-res-image]');
      if (image) {
        var src = produit.featured_image || '';
        if (src) { image.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=800'; image.hidden = false; } else { image.hidden = true; }
      }
      var nom = $(el, '[data-hm-quiz-res-nom]');
      if (nom) nom.textContent = produit.title || '';

      /* Valeurs affichées = valeurs des options Shopify de la variante (comme le tiroir de panier). */
      var v = variante || varianteLien;
      ligneResultat('longueur', v.options[0]);
      if (r.famille === 'perruque') {
        ligneResultat('quantite', '');
        ligneResultat('lace', v.options[1]);
        ligneResultat('bonnet', v.options[2]);
      } else {
        ligneResultat('quantite', casRare ? r.paquets + ' ' + (r.paquets > 1 ? config.textes.paquetPluriel : config.textes.paquetSingulier) : v.options[1]);
        ligneResultat('lace', '');
        ligneResultat('bonnet', '');
      }

      var lienFiche = donnees.url + '?variant=' + encodeURIComponent(varianteLien.id);
      var achat = $(el, '[data-hm-quiz-res-achat]');
      var blocCasRare = $(el, '[data-hm-quiz-res-cas-rare]');
      if (achat) achat.hidden = casRare;
      if (blocCasRare) blocCasRare.hidden = !casRare;

      if (casRare) {
        var lienCasRare = $(el, '[data-hm-quiz-res-cas-rare-lien]');
        if (lienCasRare) {
          lienCasRare.href = lienFiche;
          lienCasRare.textContent = remplacer(lienCasRare.getAttribute('data-texte'), { produit: produit.title });
        }
        return;
      }

      var total = $(el, '[data-hm-quiz-res-total]');
      if (total) total.textContent = moneyInsecable(variante.price, config.moneyFormat);

      var t = (fiche && fiche.textes) || {};
      var reglages = (fiche && fiche.reglages) || {};

      /* Paiement en plusieurs fois : même texte, même calcul et même mise en forme que la fiche
         (seul le premier mot reste en secondaire). */
      var echeances = $(el, '[data-hm-quiz-res-echeances]');
      if (echeances) {
        var nb = num(reglages.echeances);
        if (t.echeances && nb > 0) {
          var texte = String(t.echeances).replace('[montant]', money(Math.round(variante.price / nb), config.moneyFormat));
          var espace = texte.indexOf(' ');
          echeances.innerHTML = espace === -1 ? '<b>' + esc(texte) + '</b>' : esc(texte.slice(0, espace)) + ' <b>' + esc(texte.slice(espace + 1)) + '</b>';
          echeances.hidden = false;
        } else {
          echeances.hidden = true;
        }
      }

      /* Ligne de statut : même règle et même rendu que la fiche, décidés par assets/hm-livraison.js
         (champ surCommande calculé par la fiche ; textes de la fiche). */
      var dispo = $(el, '[data-hm-quiz-res-dispo]');
      if (dispo) {
        var variantesFiche = (fiche && (fiche.variantesMeches || fiche.variantes)) || [];
        var vFiche = variantesFiche.filter(function (x) { return String(x.id) === String(variante.id); })[0];
        var point = $(el, '[data-hm-quiz-res-point]');
        var texteDispo = $(el, '[data-hm-quiz-res-dispo-texte]');
        if (t.livraison) {
          var date = L.dateTexte(L.delai(r.handle, variante.options, num(reglages.delai)), reglages.locale);
          var ligne = L.ligneStatut(r.handle, !!(vFiche && vFiche.surCommande), date, t);
          if (point) point.classList.toggle('est-attente', ligne.attente);
          texteDispo.innerHTML = ligne.html;
          dispo.hidden = false;
        } else {
          dispo.hidden = true;
        }
      }

      /* Garanties : la liste de la fiche, telle quelle (textes et icônes). */
      var garanties = $(el, '[data-hm-quiz-res-garanties]');
      if (garanties) {
        garanties.innerHTML = '';
        if (donnees.fiche && donnees.fiche.garanties) {
          var liste = document.importNode(donnees.fiche.garanties, true);
          $$(liste, '[data-shopify-editor-block]').forEach(function (n) { n.removeAttribute('data-shopify-editor-block'); });
          garanties.appendChild(liste);
        }
      }

      var lien = $(el, '[data-hm-quiz-res-lien]');
      if (lien) lien.href = lienFiche;
      var erreur = $(el, '[data-hm-quiz-res-erreur]');
      if (erreur) erreur.hidden = true;

      await chargerCssResultat();
    }

    /* ---------- Ajout au panier : même appel et mêmes événements que assets/hm-produit.js
       (onSubmit) — cart/add.js avec les sections groupées, puis variant:add et cart:change, qui
       ouvrent le tiroir de panier du thème. La fenêtre du quiz se ferme pour le laisser voir. */
    var boutonPanier = $(el, '[data-hm-quiz-res-panier]');
    var textePanier = boutonPanier ? boutonPanier.textContent : '';
    if (boutonPanier) {
      boutonPanier.addEventListener('click', async function () {
        var variante = resultatAffiche && resultatAffiche.variante;
        if (!variante || boutonPanier.getAttribute('aria-busy') === 'true') return;
        var t = (resultatAffiche.fiche && resultatAffiche.fiche.textes) || {};
        var erreur = $(el, '[data-hm-quiz-res-erreur]');
        var root = racine();
        boutonPanier.setAttribute('aria-busy', 'true');
        if (t.boutonChargement) boutonPanier.textContent = t.boutonChargement;
        if (erreur) erreur.hidden = true;
        emit('theme:loading:start');
        var sections = [];
        emit('cart:prepare-bundled-sections', { sections: sections });
        var res, json;
        try {
          res = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ items: [{ id: variante.id, quantity: 1 }], sections: sections.join(',') })
          });
          json = await res.json();
        } catch (err) {
          res = { ok: false }; json = { description: '' };
        }
        emit('theme:loading:end');
        boutonPanier.removeAttribute('aria-busy');
        boutonPanier.textContent = textePanier;
        if (res.ok) {
          var cartType = window.themeVariables && window.themeVariables.settings.cartType;
          if (cartType === 'page') { location.href = root + 'cart'; return; }
          /* Relecture du panier. L'ajout est déjà validé côté Shopify : cet appel ne sert qu'à
             obtenir l'état complet (item_count) et le HTML du tiroir. Quand il échouait — coupure
             réseau entre les deux requêtes, ou réponse non JSON, ce second appel ne contrôlant
             pas res.ok —, l'exception partait dans le vide : ni tiroir, ni compteur, ni message,
             alors que l'article était bien au panier. La cliente recommençait et ajoutait deux
             fois. On se rabat désormais sur cart:refresh, que le thème traite en rechargeant
             compteur, pastille et contenu du tiroir depuis le serveur. Le tiroir ne s'ouvre pas
             dans ce cas : refreshCart se contente de remplacer son contenu.

             La fenêtre se ferme aussi sur ce chemin, sinon la cliente reste sur l'écran de
             résultat sans que rien ne se passe. Raison « complete » comme au succès : c'est la
             seule valeur qui n'écrit pas CLE_FERME, et le parcours est bien terminé — seul
             l'ajout a échoué. Elle ne marque pas le quiz comme fait, CLE_FAIT étant déjà à 1
             depuis la validation de l'e-mail, bien avant l'affichage du résultat. */
          var cart;
          try {
            cart = await (await fetch(root + 'cart.js')).json();
          } catch (err) {
            fermerFenetre('complete');
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            return;
          }
          cart.sections = json.sections;
          fermerFenetre('complete');
          document.documentElement.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: json.items || [json], cart: cart } }));
          emit('cart:change', { baseEvent: 'variant:add', cart: cart });
        } else {
          if (erreur) {
            erreur.innerHTML = esc(t.erreur || '') + (json.description ? ' <small>' + esc(json.description) + '</small>' : '');
            erreur.hidden = false;
          }
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }
      });
    }

    /* ---------- Déclenchement : en dernier, une fois tout le reste déclaré. Avec « Forcer
       l'affichage », ouvrirFenetre() s'exécute en synchrone ; placée plus haut, elle lisait des
       variables pas encore initialisées (piège rencontré plusieurs fois, voir
       reference/RECAP-QUIZ.md). ---------- */
    /* Page dédiée : le quiz est affiché dans la page dès que ses données sont chargées, sans
       fenêtre ni ouverture automatique, et sans prendre le focus au chargement. */
    function afficherDansPage() {
      chargerDonnees().then(function () {
        el.hidden = false;
        panneau.hidden = false;
        initialiserLongueurs();
        aller('accroche', true);
      }).catch(function (e) {
        console.warn('[hm-popup-quiz] Affichage impossible :', e);
      });
    }

    if (modePage) {
      afficherDansPage();
    } else if (forcerEditeur) {
      if (autoPage) ouvrirFenetre();
    } else if (autoPage && !autoBloquee) {
      var delaiMs = estProduit ? num(config.delaiProduitMs) : num(config.delaiMs);
      minuteur = setTimeout(essayerOuvrir, Math.max(1000, delaiMs));
      window.addEventListener('scroll', surScroll, { passive: true });
    }
    }
  }

  if (!window.customElements.get('hm-popup-quiz')) {
    window.customElements.define('hm-popup-quiz', HmPopupQuiz);
  }
})();
